import React from "react";

export default () => <svg viewBox="0 0 32 32" fill="none">
  <path fill="currentColor" d="M31.331 8.52a4.02 4.02 0 00-2.829-2.847C26.007 5 16 5 16 5S5.993 5 3.498 5.673A4.02 4.02 0 00.668 8.52C0 11.032 0 16.273 0 16.273s0 5.24.669 7.752c.368 1.386 1.452 2.432 2.829 2.802C5.993 27.5 16 27.5 16 27.5s10.007 0 12.502-.673c1.377-.37 2.461-1.416 2.83-2.802.668-2.512.668-7.752.668-7.752s0-5.24-.669-7.753zM12.727 21.03v-9.515l8.364 4.758-8.364 4.758z"/>
</svg>
